import { useEffect, useRef, useState } from 'react';

import { getLoras } from '@/services';
import type { Lora } from '@/types';
import { useSearchParams } from 'next/navigation';
import { KEY_SORT } from '../constants';

const PAGE_SIZE = 20;

const useFetchList = () => {
  const [loading, setLoading] = useState(false);
  const dataRef = useRef([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<Lora[]>([]);
  const searchParam = useSearchParams();
  const search = searchParam.get('search');
  const totalLike = searchParam.get(KEY_SORT.LIKE) ?? undefined;
  const createdAt = searchParam.get(KEY_SORT.CREATED) ?? undefined;
  const getTotalRunDefault = () => {
    if (createdAt || totalLike) return undefined;
    return 'DESC';
  }
  const totalRun = searchParam.get(KEY_SORT.RUN) ?? getTotalRunDefault();

  const getSortParams = () => {
    return JSON.stringify({ 
      createdAt, 
      runCount: totalRun, 
      likeCount: totalLike
    })
  }

  const getFilterParams = () => {
    return search ? JSON.stringify({ name: search }) : undefined;
  }

  const getListModels = async (page: number) => {
    setLoading(true);
    const res = await getLoras(
      PAGE_SIZE, 
      PAGE_SIZE * (page - 1), 
      getSortParams(),
      getFilterParams(),
    );
    if (page === 1) {
      dataRef.current = [];
      setData([]);
    }
    dataRef.current = dataRef.current.concat(res.data.items);
    setData(dataRef.current);
    setLoading(false);
  };

  const loadMore = (page: number) => {
    setCurrentPage(page);
    getListModels(page);
  };

  useEffect(() => {
    setCurrentPage(1);
    getListModels(1);
  }, [search, createdAt, totalLike, totalRun]);

  return {
    list: data,
    loading,
    loadMore,
    currentPage,
    setCurrentPage,
  };
};

export default useFetchList;
